export const api_params = {
  LOGIN_HOST_URL: 'Users/AuthenticateTego',
  REGISTER_HOST_URL: 'Users/Register/Tego',
  FORGOT_PASSWORD_HOST_URL: 'Users/ForgotPassword?email=',
  LOGOUT_HOST_URL: 'Users/Logout',
  REFRESH_TOKEN_HOST_URL: 'Users/RefreshToken',
  VERIFY_CODE_HOST_URL: 'Users/verifyCode?code=',

  DEPARTMENT_LIST_HOST_URL: 'provider/departments',
  USER_PROFILE_HOST_URL: 'provider/get/userProfile',
  CLEAR_DATA_HOST_URL: 'provider/clearData?type=',
  UPDATE_USER_HOST_URL: 'provider/userAccount',

  SEND_INVITE_HOST_URL: 'provider/sendInvite',

  REMOVER_MEMBER_HOST_URL: 'provider/remove/member',

  GET_MEMBERS_HOST_URL: 'procurement/get/Members',

  GET_BOUNTIES_HOST_URL: 'procurement/get/bounties',
  UPDATE_BOUNTY_HOST_URL: 'procurement/updateBounty',

  GET_DEALS_HOST_URL: 'procurement/get/deals',
  CLAIM_DEAL_HOST_URL: 'procurement/claimDeal',
  GET_LEADERBOARD_HOST_URL: 'procurement/get/leaderboard?',

  GET_DAILY_CHECKS_HOST_URL: 'procurement/dailyChecks',
  UPDATE_DAILY_CHECK_HOST_URL: 'procurement/updateProduct',

  GET_DAILY_CHECKS_HISTORY_HOST_URL: 'procurement/dailyChecksHistory',
  GET_DEALS_HISTORY_HOST_URL: 'procurement/dealsHistory',
  GET_BOUNTIES_HISTORY_HOST_URL: 'procurement/bountiesHistory',

  GET_IMPACTS_HOST_URL: 'procurement/get/Impacts',
  GET_INDIVIDUAL_IMPACTS_HOST_URL: 'procurement/get/IndividualImpacts',

  GET_REVIEWS_HOST_URL: 'storage/myReviews',
  CLAIM_POINTS_HOST_URL: 'storage/claimPoints?',

  GET_PLAY_PRODUCTS_HOST_URL: 'storage/productsList',
  TRANSMIT_PRODUCT_HOST_URL: 'storage/transmitProduct',
  ADJUST_PRODUCT_HOST_URL: 'storage/adjustProduct',
  REJECT_DEAL_HOST_URL: 'procurement/rejectDeal',
}
